<script setup lang="ts">
import LogoImage from "@/assets/images/logo.svg";
</script>

<template>
  <div
    class="flex h-screen flex-col items-center justify-center gap-8 tracking-tight md:flex-row md:gap-32"
  >
    <div class="order-2 grid gap-4 text-center leading-relaxed md:order-1 md:text-left">
      <h1 class="text-3xl font-bold leading-snug text-[#222] md:text-5xl md:leading-tight">
        <span>ERROR<em>!</em> </span>
        <br />
        페이지를<br class="hidden md:block" />
        찾을 수 없어요.
      </h1>
      <p class="text-sm font-normal leading-relaxed text-gray-500 md:text-lg">
        요청하신 페이지가 존재하지 않습니다.<br />
        다른 페이지로 이동해 주세요.
      </p>
      <NuxtLink to="/">
        <Button class="mt-4">메인으로 돌아가기</Button>
      </NuxtLink>
    </div>
    <div class="order-1 md:order-2">
      <img :src="LogoImage" alt="Logo" class="m-auto w-[250px] pl-2 md:w-[350px]" />
    </div>
  </div>
</template>
